import * as React from 'react';

import { PK } from 'common/types';
import { useSeriesList } from 'modules/series/queries';

import StaticPicker from './StaticPicker';

interface PickerProps {
  pk?: PK;
  collectionItems?: PK[];
}

const SeriesPicker = ({ pk, collectionItems }: PickerProps) => {
  const { data: seriesListData } = useSeriesList();
  const seriesList = seriesListData?.values;

  return (
    <StaticPicker
      pk={pk}
      divider={false}
      sectionTitle="Add series"
      contentList={seriesList ?? []}
      collectionItems={collectionItems ?? []}
      forceOpen
    />
  );
};

export default SeriesPicker;
